/*
saikrishna 11/03/2022 3075154998 changed the paginationOptions
 */
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function ReportMasterSearchTable({
  setValue,
  searchData,
  setSelectedRows,
  selectedRows,
  setBreCode,
  handleClose,
  setRuleCode,
  handleDialog,
}) {
  const columns = [
    {
      title: 'Display Name',
      field: 'displayName',
    },
    {
      title: 'Rule Group Code',
      field: 'code',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  useEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData]);

  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/search/all`;
                const bodyObj = {
                  code: searchData?.code ? searchData.code : '',
                  displayName: searchData?.displayName ? searchData.displayName : '',
                  description: searchData?.description ? searchData.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page:
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  returnType: '',
                };
                httpPaginationPost(url, bodyObj).then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObject;

                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(response.data.response.resultObject.length === 1);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onRowClick={(event, rowData) => {
              setRuleCode(rowData?.code);
              handleDialog();
            }}
          />
        </div>
      </Grid>
    </>
  );
}
